var React = require('react');

function IconLoading (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"50","cy":"50","fill":"none","stroke":"#fff","strokeWidth":"4","r":"35","strokeDasharray":"164.93361431346415 56.97787143782138","transform":"rotate(84 50 50)"},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","calcMode":"linear","values":"0 50 50;360 50 50","keyTimes":"0;1","dur":"1s","begin":"0s","repeatCount":"indefinite"})));
}

IconLoading.defaultProps = {"width":"35","height":"35","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","className":"lds-rolling","style":{"background":"0 0"}};

module.exports = IconLoading;

IconLoading.default = IconLoading;
